// 上层平台
import UpperLogin from '../view/UpperStrata/UpperLogin'
import SummaryPage from '../view/UpperStrata/Summary/SummaryPage'
import PortraitOfEnterprisesInThePark from '../view/UpperStrata/PortraitOfEnterprisesInThePark/PortraitOfEnterprisesInThePark'
import ParkDisplayScreen from '../view/UpperStrata/ParkDisplayScreen/ParkDisplayScreen'
import ParkDisplayScreen2 from '../view/UpperStrata/ParkDisplayScreen/ParkDisplayScreen2'
import ParkDisplayScreenAlarm from '../view/UpperStrata/ParkDisplayScreen/ParkDisplayScreenAlarm'

// 上层平台 ——————  信息发布
import InformationDeliveryNav from '../view/UpperStrata/Summary/InformationDelivery/InformationDeliveryNav'
import GroupProfileInfo from '../view/UpperStrata/Summary/InformationDelivery/GroupProfile/GroupProfileInfo'
import GroupProfileInfoModify from '../view/UpperStrata/Summary/InformationDelivery/GroupProfile/GroupProfileInfoModify'
import AddHonorQualification from '../view/UpperStrata/Summary/InformationDelivery/HonorQualification/AddHonorQualification'
import ModifyHonorQualification from '../view/UpperStrata/Summary/InformationDelivery/HonorQualification/ModifyHonorQualification'
import HonorQualificationManage from '../view/UpperStrata/Summary/InformationDelivery/HonorQualification/HonorQualificationManage'
import UpperInformationAddYqNotice from '../view/UpperStrata/Summary/InformationDelivery/InformationNotice/AddYqNotice'
import UpperInformationModifyYqNotice from '../view/UpperStrata/Summary/InformationDelivery/InformationNotice/ModifyYqNotice'
import UpperInformationYqNoticeManagement from '../view/UpperStrata/Summary/InformationDelivery/InformationNotice/YqNoticeManagement'

// 上层平台 ——————  账号管理
import UpperStrataAccountManageNav from '../view/UpperStrata/Summary/AccountManage/AccountManageNav'
import SuperiorAccountManagement from '../view/UpperStrata/Summary/AccountManage/SuperiorAccount/SuperiorAccountManagement'
import SuperiorAccountAdd from '../view/UpperStrata/Summary/AccountManage/SuperiorAccount/SuperiorAccountAdd'
import SuperiorAccountModify from '../view/UpperStrata/Summary/AccountManage/SuperiorAccount/SuperiorAccountModify'
import SuperiorRoleManagement from '../view/UpperStrata/Summary/AccountManage/SuperiorRole/SuperiorRoleManagement'
import SuperiorRoleAdd from '../view/UpperStrata/Summary/AccountManage/SuperiorRole/SuperiorRoleAdd'
import SuperiorRoleModify from '../view/UpperStrata/Summary/AccountManage/SuperiorRole/SuperiorRoleModify'

export default [
    /* 上层平台 —————————————————————————————————————————————————— */
    {
        path: '/upper_login',
        name: 'upper-login',
        component: UpperLogin
    },
    {
        path: '/upper_strata/summary_page',
        name: 'summary-page',
        components: {
            firstPage: SummaryPage
        }
    },
    {
        path: '/upper_strata/portrait_of_enterprises_in_the_park/:id',
        name: 'PortraitOfEnterprisesInThePark',
        component: PortraitOfEnterprisesInThePark
    },
    {
        path: '/upper_strata/park_display_screen',
        name: 'ParkDisplayScreen',
        component: ParkDisplayScreen
    },
    {
      path: '/upper_strata/park_display_screen_alarm',
      name: 'ParkDisplayScreenAlarm',
      component: ParkDisplayScreenAlarm
    },
    {
        path: '/upper_strata/intelligent_brain',
        name: 'ParkDisplayScreen2',
        component: ParkDisplayScreen2
    },
    {
        path: '/upper_strata/park_display_screen2',
        name: 'ParkDisplayScreen2',
        component: ParkDisplayScreen2
    },
    {
        path: '/upper_strata/information/group_profile_info',
        name: 'upper-information-group-profile-info',
        components: {
            default: InformationDeliveryNav,
            a: GroupProfileInfo
        }
    },
    {
        path: '/upper_strata/information/group_profile_info_modify',
        name: 'upper-information-group-profile-info-modify',
        components: {
            default: InformationDeliveryNav,
            a: GroupProfileInfoModify
        }
    },
    {
        path: '/upper_strata/information/add_honor_qualification',
        name: 'upper-information-add-honor-qualification',
        components: {
            default: InformationDeliveryNav,
            a: AddHonorQualification
        }
    },
    {
        path: '/upper_strata/information/modify_honor_qualification/:id',
        name: 'upper-information-modify-honor-qualification',
        components: {
            default: InformationDeliveryNav,
            a: ModifyHonorQualification
        }
    },
    {
        path: '/upper_strata/information/honor_qualification_manage',
        name: 'upper-information-honor-qualification-manage',
        components: {
            default: InformationDeliveryNav,
            a: HonorQualificationManage
        }
    },
    // 通知公告
    {
        path: '/upper_strata/information/add_yq_notice/:type',
        name: 'upper-information-add-yq-notice',
        components: {
            default: InformationDeliveryNav,
            a: UpperInformationAddYqNotice
        }
    },
    {
        path: '/upper_strata/information/modify_yq_notice/:type/:id',
        name: 'upper-information-modify-yq-notice',
        components: {
            default: InformationDeliveryNav,
            a: UpperInformationModifyYqNotice
        }
    },
    {
        path: '/upper_strata/information/yq_notice_management/:type',
        name: 'upper-information-yq-notice-manage',
        components: {
            default: InformationDeliveryNav,
            a: UpperInformationYqNoticeManagement
        }
    },
    // 通知公告

    // 账号管理
    {
        path: '/upper_strata/account/superior_account_management',
        name: 'upper-account-superior-account-management',
        components: {
            default: UpperStrataAccountManageNav,
            a: SuperiorAccountManagement
        }
    },
    {
        path: '/upper_strata/account/superior_account_add',
        name: 'upper-account-superior-account-add',
        components: {
            default: UpperStrataAccountManageNav,
            a: SuperiorAccountAdd
        }
    },
    {
        path: '/upper_strata/account/superior_account_modify/:id',
        name: 'upper-account-superior-account-modify',
        components: {
            default: UpperStrataAccountManageNav,
            a: SuperiorAccountModify
        }
    },
    {
        path: '/upper_strata/account/superior_role_management',
        name: 'upper-account-superior-role-management',
        components: {
            default: UpperStrataAccountManageNav,
            a: SuperiorRoleManagement
        }
    },
    {
        path: '/upper_strata/account/superior_role_add',
        name: 'upper-account-superior-role-add',
        components: {
            default: UpperStrataAccountManageNav,
            a: SuperiorRoleAdd
        }
    },
    {
        path: '/upper_strata/account/superior_role_modify/:id',
        name: 'upper-account-superior-role-modify',
        components: {
            default: UpperStrataAccountManageNav,
            a: SuperiorRoleModify
        }
    },



    // 账号管理
    /* 上层平台 —————————————————————————————————————————————————— */
]



// WEBPACK FOOTER //
// ./src/router/UpperStrata.js